<i18n>
{
  "en":{
    "q1": "May I cancel subscription whenever I feel like?"
  },
  "zhHant":{
    "q1": "我不想繼續使用時，隨時可以取消訂閱嗎？"
  },
  "ja":{
    "q1":"Xロボットモンはいつでも解約できますか？"
  },
  "ko":{
    "q1":"내가 더 이상 사용하고 싶지 않을 때 언제든지 구독을 취소할 수 있습니까?"
  }
}
</i18n>
<template>
  <v-expansion-panel>
    <v-expansion-panel-content>
      <template v-slot:header>
        <div>{{ $t('q1') }}</div>
      </template>
      <v-card>
        <v-card-text v-if="$i18n.locale === 'ja'">
          <p>はい、いつでも解約のお手続きができます。</p>
          <p>［有料版］ボタンを押すとライセンスの状況が表示され、その画面から解約のお手続きに進めます。</p>
        </v-card-text>
        <v-card-text v-if="$i18n.locale === 'zhHant'">
          <p>是的！您可以在任何時間取消訂閱。</p>
          <p>可以自己點擊 “標準版” 按鈕先查看現在的訂閱狀態，然後再點擊退訂按鈕來退訂喔！</p>
        </v-card-text>
        <v-card-text v-if="$i18n.locale === 'en'">
          <p>Yes! Feel free to cancel your subscription at any time.</p>
          <p>You can tap 'STANDARD' to check your subscription status, and if you need, unsubscribe from there.</p>
        </v-card-text>
        <v-card-text v-if="$i18n.locale === 'ko'">
          <p>네! 언제라도 구독을 취소할 수 있습니다.</p>
          <p>
            "일반버전" 버튼을 클릭하여 현재 구독상태를 확인하신 후 청약철회 버튼을 클릭하시면 청약철회를 하실 수
            있습니다!
          </p>
        </v-card-text>
      </v-card>
    </v-expansion-panel-content>
  </v-expansion-panel>
</template>
<script>
export default { components: {} };
</script>